define('shared/initializer/form/adapters/mixins/ConversionTrackable',[
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/state', 
    'shared/lib/RSVP',
    'shared/util/tracking/pageName'
], function (
    FormDataDispatcher,
    state, 
    RSVP,
    pageNameUtil
) {
    'use strict';
    function Ctor() { }

    Ctor.prototype.doBeforeSubmit = function(data) {
        var me = this;

        var dispatcher = new FormDataDispatcher(me.$form);
        return dispatcher.dispatch({
            items:{
                'href':
                {
                    sources:
                        [{
                            retrieve: function(){
                                return RSVP.resolve(window.location.href);
                            },
                        }],
                    targets:
                        [{
                            type: 'state',
                            key: 'session.conversion_page_url'
                        }]
                },
                'pagename':
                {
                    sources:
                        [{
                            retrieve: function(){return pageNameUtil.getConversionPageName.call(me);}
                        }],
                    targets:
                        [{
                            type: 'state',
                            key: 'session.conversion_page'
                        }]
                }
            },
            timeout: 1000 * 60 * 60
        })
        .then(function(){
            return data;
        });
    };

    return Ctor;
});
